import {Box, Stack, Typography} from "@mui/material";
import React, {useEffect} from "react";
import {useDebounce} from "../../../../hooks/useDebounce";
import Chart from "react-apexcharts";
import {blue, grey} from "@mui/material/colors";
import {useDashboard} from "../../../../context/DashboardContext";

export const TagsUsageChart = ({project}) => {
  const {nodeUsage, tagUsage, updatedValue, refreshTagsUsage} = useDashboard();
  const debouncedValue = useDebounce(updatedValue, 3000);

  useEffect(() => {
    if (project?.id) {
      console.log("REFRESH TAGS")
      refreshTagsUsage();
    }
  }, [project?.id, debouncedValue, refreshTagsUsage]);

  // Process chart data
  const chartLabels = [];
  const chartValues = [];

  for (const key of Object.keys(tagUsage).sort()) {
    if (tagUsage[key]) {
      chartLabels.push(key);
      chartValues.push(tagUsage[key]);
    }
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: {show: false}
    },
    colors: [blue[500]], // <-- Set all bars to this color
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: false,
      }
    },
    dataLabels: {
      enabled: true
    },
    xaxis: {
      categories: chartLabels,
    },
  };

  const chartSeries = [
    {
      name: 'Usage',
      data: chartValues
    }
  ];

  return (
    <Stack direction="column" gap={0}
           justifyContent={"space-between"}
           sx={{borderRadius: 3, flex: 1, p: 0, height: "calc(100% - 0px)"}}
           className={"border-shadow"}>
      <Box sx={{px: 2, pt: 2}}>
        <Typography variant={"body1"} color={grey[500]}>TAGS USAGE</Typography>
      </Box>
      <Chart options={chartOptions} series={chartSeries} type="bar" height={300}/>
    </Stack>
  );
};
